export const components = {
  checkbox: {
    root: {
      filledBackground: '#fff',
      checkedBackground: '#fff',
      checkedHoverBackground: '#fff',
      disabledBackground: 'none',
      borderColor: 'var(--primary-color)',
      checkedDisabledBorderColor: '#ccc',
      width: '20px',
      height: '20px',
    },
    icon: {
      checkedColor: 'var(--primary-color)',
      checkedHoverColor: 'var(--primary-color)',
    },
  },
  inputtext: {
    css: `
      .p-inputtext:disabled,
      .p-textarea:disabled,
      .p-select.p-disabled,
      .p-autocomplete.p-disabled,
      .p-inputnumber.p-disabled,
      .p-datepicker.p-disabled,
      .p-multiselect.p-disabled {
        opacity: 0.4;
      }
      /* The wrappers above already dim themselves via p-disabled. If the inner
         <input class="p-inputtext"> is also :disabled, browsers multiply the
         two opacities (0.4 * 0.4 = 0.16) and the text becomes nearly invisible.
         Keep the inner input at full opacity so only the wrapper dims. */
      .p-select.p-disabled .p-inputtext:disabled,
      .p-autocomplete.p-disabled .p-inputtext:disabled,
      .p-inputnumber.p-disabled .p-inputtext:disabled,
      .p-datepicker.p-disabled .p-inputtext:disabled,
      .p-multiselect.p-disabled .p-inputtext:disabled {
        opacity: 1 !important;
      }
    `,
  },
};
